import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { get_order_details } from '../../store/reducers/orderReducer'
import { backend_url_img } from '../../api/server'
import { useTranslation } from 'react-i18next'
import { socket } from '../../utils/utils'

const OrderDetails = () => {
  const { orderId } = useParams()
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const isRTL = currentLanguage === 'ar' || currentLanguage === 'kr'
  // const { userInfo } = useSelector((state) => state.auth)
  const { myOrder } = useSelector((state) => state.order)
  // const { currencyIQD } = useSelector((state) => state.dashboard)



  useEffect(() => {
    dispatch(get_order_details(orderId))
  }, [orderId])

  useEffect(() => {
    socket.on('orderStatusUpdate', (data) => {
      dispatch(get_order_details(data.orderId))
    })
  }, [])


  const getProductName = (product) => {
    switch (currentLanguage) {
      case 'ar':
        return product?.arName
      case 'kr':
        return product?.kuName
      default:
        return product?.enName
    }
  }

  return (
    <div className="bg-white">
      {/* <h2 className='text-slate-600 font-semibold'>#{myOrder._id} , <span className='pl-1'>{myOrder.date}</span> </h2> */}
      <div className="grid grid-cols-2 gap-3">
        <div className="flex flex-col gap-1">
          <h2 className="text-slate-600 text-sm font-semibold ">
            {t('orderS.deliver_to')} : {myOrder.shippingInfo?.place}{' '}
          </h2>
          <p>
            <span className="bg-blue-100 text-blue-800 text-xs font-medium mr-2 px-2 py-2 rounded">
              {myOrder.shippingInfo?.place}{' '}
            </span>
            <span className="text-slate-600 text-sm">
              {myOrder.shippingInfo?.address}
              {'/ '}
              {myOrder.shippingInfo?.phone}
              {'/ '}
              {myOrder.shippingInfo?.city}
            </span>
          </p>
          {/* <p className="text-slate-600 text-md font-semibold">
            Email To {userInfo.email}
          </p> */}
        </div>

        <div className={`text-slate-600 ${isRTL ? 'row-reverse' : ''}`}>
          <h2 className="text-md font-bold">
            {t('dashboardS.price')} : {myOrder.price} {t('products.currency')}{' '}
            {'- '} {t('dashboardS.include_shipping')}
          </h2>
          <p className="text-dm py-2">
            {' '}
            {t('dashboardS.payment_status')} :{' '}
            <span
              className={`py-[1px] text-sm px-3 ${
                myOrder.payment_status === 'paid'
                  ? 'bg-green-300 text-green-800'
                  : 'bg-red-300 text-red-800'
              } rounded-md`}
            >
              {' '}
              {myOrder.payment_status}{' '}
            </span>{' '}
          </p>

          <p className="text-md">
            {' '}
            {t('dashboardS.order_status')} :{' '}
            <span
              className={`py-[1px] text-sm px-3 ${
                myOrder.delivery_status === 'delivered'
                  ? 'bg-green-300 text-green-800'
                  : 'bg-red-300 text-red-800'
              } rounded-md`}
            >
              {' '}
              {t(`orderS.${myOrder.delivery_status}`)}{' '}
            </span>{' '}
          </p>
        </div>
        <div className="flex flex-col gap-1 mt-2 mb-6 w-full">
          <label htmlFor="orderNote" className="text-slate-600 text-sm font-bold">
            {' '}
            {t('orderS.order_note')}{' '}
          </label>
          <textarea
            value={myOrder?.order_note}
            type="text"
            className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md"
            name="orderNote"
            id="orderNote"
            placeholder={t('orderS.order_note')}
            disabled
          />
        </div>
      </div>

      <div className="mt-4">
        <h2 className="text-slate-600 text-md pb-2   font-bold">
          {t('home.productList')}{' '}
        </h2>
        <div className="flex w-full gap-5 flex-col">
          {/* {myOrder.products?.map((p, i) => (
            <div key={i}>
              <div className="flex gap-5 justify-start items-center text-slate-600">
                <div className="flex gap-2">
                  <img className="w-[55px] h-[55px]" src={p.image} alt="" />
                  <div className="flex text-sm flex-col justify-start items-start">
                    <Link> {p.name} </Link>
                    <p>
                      {' '}
                      <span>Brand : {p.brand}</span>{' '}
                    </p>
                    <p>
                      <span>Quantity : {p.quantity}</span>
                    </p>
                  </div>
                </div>

                <div className="pl-4 flex flex-col">
                  <h2 className="text-md text-green-800">
                    ${p.price - Math.floor((p.price * p.discount) / 100)}
                  </h2>
                  <p className="line-through">{p.price}</p>
                  <p>-{p.discount}%</p>
                </div>
              </div>
            </div>
          ))} */}
          {myOrder.products?.map((p, i) => (
            <div
              className="flex  bg-white shadow-md border border-slate-50 p-2 flex-col gap-2"
              key={p._id}
            >
              <div className="flex justify-start items-center gap-4">
                <h2 className="text-sm text-slate-600 font-bold">
                  {getProductName(p.productInfo)}
                </h2>
                <div className="flex justify-center items-center ">
                  <span className="font-medium">
                    {t('products.product_code')}: {p.productInfo.productCode}
                  </span>
                </div>
              </div>

              <div className="grid grid-rows-2 grid-flow-col sm:grid-flow-row gap-4">
                <div className="row-span-3">
                  <div className="flex gap-2 justify-start items-center">
                    <img
                      className="w-[100px] h-auto"
                      src={`${backend_url_img}/${p?.productInfo.images[0]}`}
                      alt={p.productInfo.enName || 'Product Image'}
                    />
                    <div className="px-2  text-white">
                      {p.selectedPack ? (
                        <div
                          className="flex flex-col text-sm font-semibold w-full gap-2"
                          key={p.selectedPack._id || p.selectedPack.pack.code}
                        >
                          {/* Pack Info */}
                          <div className="flex gap-2 items-center px-2 py-2 bg-darkRed justify-center border rounded-md ">
                            <span className="font-base">
                              {p.selectedPack.pack?.code} ×{' '}
                              {getProductName(p.selectedPack.pack)}
                            </span>
                            <span className="text-sm font-normal text-white">
                              ({new Intl.NumberFormat('en-US').format(p.selectedPack?.price)}{' '}
                              {t('products.currency')})
                            </span>
                          </div>

                          {/* Properties */}
                          <div className="flex flex-col gap-1 px-1">
                            {p.selectedPack.properties?.length > 0 ? (
                              p.selectedPack.properties.map(
                                (prop, propIndex) => (
                                  <div
                                    key={prop._id || propIndex}
                                    className="flex items-center gap-2"
                                  >
                                    <span className="font-light">{prop}</span>
                                  </div>
                                )
                              )
                            ) : (
                              <span className="text-sm font-light text-slate-400">
                                {t('home.no_properties_available')}
                              </span>
                            )}
                          </div>
                        </div>
                      ) : (
                        <span className="text-sm font-light text-slate-400">
                          {t('home.no_pack_selected')}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row-span-3">
                  <div className="flex flex-row items-center justify-center gap-4 w-auto">
                    <span className="text-lg w-auto flex-shrink-0">
                      {t('products.price')}:
                    </span>

                    <div className="flex flex-row sm:flex-row items-center gap-2">
                      <h2
                        className={`text-lg text-orange-500 ${
                          isRTL ? 'flex-row' : ''
                        }`}
                      >
                        {p.selectedPack
                          ? new Intl.NumberFormat('en-US').format(
                              p.selectedPack.price * p.selectedPack.pack.code
                            )
                          : ''}{' '}
                        {t('products.currency')}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`flex items-center  justify-start sm:justify-center text-sm font-bold ${
                  isRTL ? 'rtl text-right' : 'ltr text-left'
                } px-4`}
              >
                <h2 className="px-2 whitespace-nowrap">
                  {t('home.total_price')}:
                </h2>
                <span className="whitespace-nowrap">
                  {(() => {
                    if (!p?.selectedPack) return null

                    const packCode = Number(p.selectedPack.pack?.code) || 0
                    const quantity = Number(p.quantity) || 0
                    const packPrice = Number(p.selectedPack.price) || 0

                    const totalPrice = new Intl.NumberFormat('en-US').format((
                      packCode *
                      quantity *
                      packPrice
                    ))
                    const currency = t('products.currency')

                    return isRTL
                      ? ` ${quantity} × (${packCode} × ${packPrice.toFixed(
                          2
                        )})  = ${totalPrice} ${currency}`
                      : `${quantity} × (${packCode} × ${packPrice.toFixed(
                          2
                        )}) = ${totalPrice} ${currency}`
                  })()}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default OrderDetails
